import { gql } from 'graphql-request';

export const getPortfolioNatureStatusQuery = gql`
    query GetPortfolioNatureStatus(
        $businessCentralId: String!
        $at: DateTime
        $isic: [String!]!
        $countries: [String!]!
        $physicalRiskLevels: [GqlRiskBandLevel!]!
        $dependencyLevels: [GqlRiskBandLevel!]!
        $impactLevels: [GqlRiskBandLevel!]!
        $sonLevels: [GqlSonBandLevel!]!
    ) {
        organisation(businessCentralId: $businessCentralId, at: $at) {
            natureStatus(
                isic: $isic
                countries: $countries
                physicalRiskLevels: $physicalRiskLevels
                dependencyLevels: $dependencyLevels
                impactLevels: $impactLevels
                sonLevels: $sonLevels
            )
        }
    }
`;

export type GetPortfolioNatureStatusResult = {
    organisation: {
        natureStatus: string | null;
    } | null;
};
